export default __webpack_public_path__ + "917c3b691426d3215bf0a7ef1ba98861.png";